// extracted by mini-css-extract-plugin
export default {"resultsColumn":"resultsColumn-GR4Iq","viewChartDisabled":"viewChartDisabled-hfTQ2"};